"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arkosePublicKey = void 0;
var ENVIRONMENT;
(function (ENVIRONMENT) {
    ENVIRONMENT["DEV"] = "DEV";
    ENVIRONMENT["PROD"] = "PROD";
})(ENVIRONMENT || (ENVIRONMENT = {}));
const arkosePublicKey = (arkoseKey, isDev) => {
    const ARKOSE_PUBLIC_KEYS = {
        [ENVIRONMENT.DEV]: {
            ["login"]: "FE9DC8DA-5E83-495F-A762-582267EEACDE",
            ["signup"]: "152E1D0C-D805-4060-A111-6AC82CA6821B",
            ["wwwLogin"]: "C383A903-0809-41A2-A832-5F7ACC690EA6",
        },
        [ENVIRONMENT.PROD]: {
            ["login"]: "07EAB4B8-2D80-4234-B897-A2CD1F194866",
            ["signup"]: "EA4B65CB-594A-438E-B4B5-D0DBA28C9334",
            ["wwwLogin"]: "D99D7D11-158A-408C-A6C5-29F2B60EFADE",
        },
    };
    const environment = isDev ? ENVIRONMENT.DEV : ENVIRONMENT.PROD;
    return ARKOSE_PUBLIC_KEYS[environment][arkoseKey];
};
exports.arkosePublicKey = arkosePublicKey;
//# sourceMappingURL=constants.js.map